import { Component } from '@angular/core';
import { FileTypeConstants } from '../../../shared/constants/file-upload-type-constants';

@Component({
  selector: 'claim-pictures',
  templateUrl: './claim-pictures.component.html',
})
export class ClaimPicturesComponent {
 
  public importFiles: File[] = [];
  public acceptedFiles: string[] = FileTypeConstants.accceptedImageTypes;
 
  constructor() { }
  
  public addImportFiles(filesToImport: File[]) {
    this.importFiles = filesToImport;
  }

  public removeFile(): void {
    this.importFiles = [];
  }  
}